import hyperdom from 'hyperdom'
import format from 'root-core/utils/text/stringFormatFilter.js'

export default function (notes) {
  const urlTemplate = '<a class="note__link" href="{0}">{0}</a>'
  const findAndParseUrl = (note) => {
    return note
      .split(' ')
      .map(el => el.startsWith('http') ? parseUrl(el) : el)
      .join(' ')
  }

  const parseUrl = (url) => {
    const urlParts = url.split('\n')
    urlParts[0] = format(urlTemplate, urlParts[0])
    return urlParts.join('\n')
  }

  return notes ? notes.map((note) => {
    let productNote, departureNote, sellingCompanyNote

    if (note.productNote) {
      productNote = hyperdom.rawHtml('p', findAndParseUrl(note.productNote))
    }
    if (note.departureNote) {
      departureNote = hyperdom.rawHtml('p', findAndParseUrl(note.departureNote))
    }
    if (note.sellingCompanyNote) {
      sellingCompanyNote = hyperdom.rawHtml('p', findAndParseUrl(note.sellingCompanyNote))
    }

    return <div>
      { productNote }
      { departureNote }
      { sellingCompanyNote }
    </div>
  })
    : undefined
}
